import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import {
  findUserOption,
  getSelectedUserOptions,
  getUserDisplayName,
  normalizeSelectedUserIds,
  normalizeUserId,
} from "./departmentUserOptions";

const listboxProps = { className: "department-user-listbox" };
const popperSlotProps = {
  popper: { className: "department-user-popper" },
  paper: { className: "department-user-paper" },
};

export default function DepartmentUserAssignments({
  userOptions,
  usersLoading,
  usersError,
  managerValue,
  onManagerChange,
  selectedOperatorIds,
  onOperatorIdsChange,
  operatorMappingsLoading,
  operatorMappingError,
}) {
  const options = Array.isArray(userOptions) ? userOptions : [];
  const loading = Boolean(usersLoading || operatorMappingsLoading);
  const userPickerDisabled = Boolean(usersError);
  const operatorDisabled = Boolean(usersError || operatorMappingError || operatorMappingsLoading);

  return (
    <div className="department-user-assignments">
      <div className="form-group">
        <label className="form-label" htmlFor="department-manager-picker">
          Manager <span className="optional-tag">(Optional)</span>
        </label>
        <Autocomplete
          id="department-manager-picker"
          size="small"
          options={options}
          value={findUserOption(options, managerValue)}
          getOptionLabel={getUserDisplayName}
          isOptionEqualToValue={(option, value) =>
            normalizeUserId(option) === normalizeUserId(value)
          }
          onChange={(_event, manager) => onManagerChange(normalizeUserId(manager))}
          loading={usersLoading}
          disabled={userPickerDisabled}
          autoHighlight
          openOnFocus
          clearOnEscape
          disablePortal
          slotProps={popperSlotProps}
          ListboxProps={listboxProps}
          loadingText="Loading Production reps…"
          noOptionsText={usersError || "No eligible Production reps found"}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Search for a manager"
              error={Boolean(usersError)}
              helperText={usersError || undefined}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {usersLoading && <CircularProgress color="inherit" size={18} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="department-operator-picker">
          Production Operators <span className="optional-tag">(Optional)</span>
        </label>
        <Autocomplete
          id="department-operator-picker"
          size="small"
          multiple
          limitTags={2}
          filterSelectedOptions
          options={options}
          value={getSelectedUserOptions(options, selectedOperatorIds)}
          getOptionLabel={getUserDisplayName}
          isOptionEqualToValue={(option, value) =>
            normalizeUserId(option) === normalizeUserId(value)
          }
          onChange={(_event, operators) =>
            onOperatorIdsChange(normalizeSelectedUserIds(operators))
          }
          loading={loading}
          disabled={operatorDisabled}
          autoHighlight
          openOnFocus
          clearOnEscape
          disablePortal
          slotProps={popperSlotProps}
          ListboxProps={listboxProps}
          loadingText="Loading Production reps…"
          noOptionsText={usersError || "No eligible Production reps found"}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Search Production operators"
              error={Boolean(usersError || operatorMappingError)}
              helperText={
                usersError ||
                operatorMappingError ||
                (selectedOperatorIds.length
                  ? "Scheduling limited to selected operators."
                  : "Leave empty to allow all Production reps.")
              }
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading && <CircularProgress color="inherit" size={18} />}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </div>
    </div>
  );
}
